module.exports = __webpack_public_path__ + "img/5.8446ef32.png";